import { inject, Injectable } from '@angular/core';
import { BaseService } from '@shared/core';
import {
  IParkomatsFilterModel,
  IPaymentPointModel,
  IPaymentPointsResponseModel,
} from '@pkp-g/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaymentPointsService {
  private http = inject(BaseService);
  apiUrl = 'v1/payment_points';

  getAllPaymentPoints(filter?: IParkomatsFilterModel): Observable<IPaymentPointsResponseModel> {
    return this.http.get<IPaymentPointsResponseModel>(`${this.apiUrl}`, filter);
  }

  getPaymentPointById(id?: string): Observable<IPaymentPointModel> {
    return this.http.get<IPaymentPointModel>(`${this.apiUrl}/${id}`);
  }

  createPaymentPoint(payload: IPaymentPointModel): Observable<IPaymentPointModel> {
    return this.http.post<IPaymentPointModel>(`${this.apiUrl}`, payload);
  }

  editPaymentPoint(id: string, payload: IPaymentPointModel): Observable<IPaymentPointModel> {
    return this.http.put<IPaymentPointModel>(`${this.apiUrl}/${id}`, payload);
  }

  deletePaymentPointById(id?: string): Observable<unknown> {
    return this.http.delete<unknown>(`${this.apiUrl}/${id}`);
  }
}
